import { Link } from "react-router-dom";
import Fancybox from "../../Components/AsyncGallery";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function AwardsAndRecognititons() {

  const allImages = [
    "event-img-8.webp",
    "event-img-6.webp",
    "event-img-10.webp",
    "event-img-7.webp",
    "event-img-5.webp",
    "event-img-4.webp",
    "event-img-12.jpg",
    "event-img-3.webp",
    "event-img-2.webp",
    "event-img-9.webp",
    "event-img-1.webp",
    "event-img-11.webp",
    "award-2.webp"
  ];
  const reversedImages = [...allImages].reverse();

  return (
    <>
      <Helmet>
        <title>Awards & Achievements</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/awards-and-recognitions`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/awards-and-recognitions`} />
        <meta property="og:title" content="Awards & Achievements" />
        <meta property="og:description" content="InfinitiveHost is recognized for excellence in web hosting and server solutions, winning multiple awards for performance, reliability, and customer support." />
      </Helmet>

      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Achievements</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Awards And Recognitions
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Our Work Culture That Fuels Passion and Drives Success!
                  </p>
                   <a href="images/award/infinitivehost-award-certificate.pdf" target="_blank"
                      className="btn btn-light btn-arrow fs-14 fw-semibold rounded transition btn-height">
                      <span className="btn-arrow__text">
                            Certificate
                          <span className="btn-arrow__icon">
                              <i className="fa-solid fa-arrow-right"></i>
                          </span>
                      </span>
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 👇 FANCYBOX WRAPPER */}
      <Fancybox>
        <section className="pt-100 pb-100">
          <div className="container">
            <div className="gallery">
              <div className="video-wrapper">
                <a className="img-card" href="images/event-video.mp4" data-fancybox="video-gallery" data-caption="1">
                  <figure className="img-frame">
                    <video className="rounded shadow " muted playsInline autoPlay loop preload="metadata" > <source src="images/event-video.mp4" type="video/mp4" /> </video>
                  </figure>
                </a>
              </div>
              {reversedImages.map((img, index) => (
                <a className="img-card" href={`/images/award/${img}`} data-fancybox="gallery" data-caption="1" key={index}>
                  <figure className="img-frame">
                    <img src={`/images/award/${img}`} alt={`gallery-${index}`} title="" />
                  </figure>
                </a>
              ))}

            </div>
          </div>
        </section>
      </Fancybox>
    </>
  );
}
